import { Fragment } from 'react';
import { useAuth } from '../auth/context';
import { Dialog } from '../components/ui';
import { strings } from '../strings';
import { Keys } from './Keys';
import { TOOL_WINDOWS } from '../dock/registry';
import { designerShortcuts, shellShortcuts, toolWindowShortcuts, type Shortcut } from './shortcuts';

const s = strings.shell.shortcuts;

function ShortcutTable({ title, shortcuts }: { title: string; shortcuts: Shortcut[] }) {
  return (
    <section className="mb-4">
      <h3 className="mb-2 text-[13px] font-semibold">{title}</h3>
      <dl className="grid grid-cols-[minmax(0,1fr)_auto] gap-x-6 gap-y-1.5">
        {shortcuts.map((shortcut) => (
          <Fragment key={shortcut.id}>
            <dt className="text-fg">{shortcut.label}</dt>
            <dd className="flex items-center justify-end gap-1.5">
              {shortcut.keys.map((keys, i) => (
                <Fragment key={i}>
                  {i > 0 && <span className="text-[11px] text-fg-muted">{s.or}</span>}
                  <Keys keys={keys} sequence={shortcut.sequence} />
                </Fragment>
              ))}
            </dd>
          </Fragment>
        ))}
      </dl>
    </section>
  );
}

/** The keyboard shortcuts dialog (`?`, spec 6.1.12): the same list the palette uses for its key hints. */
export function ShortcutsDialog({ onClose }: { onClose: () => void }) {
  const networking = useAuth().config.networking?.enabled ?? false;
  return (
    <Dialog title={s.title} onClose={onClose}>
      <ShortcutTable title={s.everywhere} shortcuts={shellShortcuts(networking)} />
      <ShortcutTable title={strings.dock.shortcuts.group} shortcuts={toolWindowShortcuts(TOOL_WINDOWS)} />
      <ShortcutTable title={s.designer} shortcuts={designerShortcuts()} />
    </Dialog>
  );
}
